import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TenantMsGraphOptions } from 'app/api/models/tenant/TenantMsGraphOptions';
import { NotificationService } from 'app/api/services/notificationService';
import { MessageText, ToastService } from 'app/helpers/services/toastService';
import { TenantsService } from 'app/state/tenants.service';
import { Table } from 'primeng/table';
import { TrackRender } from 'app/shared/front-perfomance';

@TrackRender()
@Component({
  selector: 'app-tenant-emails-list-page',
  templateUrl: './tenant-email-list-page.component.html',
  styleUrls: ['./tenant-email-list-page.component.scss'],
  standalone: false,
})
export class TenantEmailsListPageComponent {
  tenantId: string = '';
  msGraphId: string = '';
  emailTemplateItems: any[] = [];
  deleteConfirmation: TenantMsGraphOptions | null = null;
  showModalWindow: boolean = false;

  constructor(
    public service: TenantsService,
    private route: ActivatedRoute,
    private toastService: ToastService,
    public notificationService: NotificationService,
  ) {}

  ngOnInit(): void {
    this.tenantId = this.route.snapshot.paramMap.get('id') ?? '';
    this.loadData();
  }

  loadData() {
    if (!this.tenantId) return;
    this.notificationService
      .getTenantMsGraphSetingsList(this.tenantId)
      .subscribe((x) => {
        this.emailTemplateItems = x;
      });
  }

  onGlobalFilter(table: Table, event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    table.filterGlobal(inputElement.value, 'contains');
    //this.toastService.showSuccess(MessageText.success);
  }

  handleDeleteClick(option: TenantMsGraphOptions) {
    this.notificationService.deleteMsGraphOptions(option.id!).subscribe(() => {
      this.notificationService
        .getTenantMsGraphSetingsList(this.tenantId)
        .subscribe((x) => {
          this.emailTemplateItems = x;
        });
    });
  }

  testEmailsOptions(optionsId: string) {
    this.notificationService.testTenantMsGraphSetingById(optionsId).subscribe({
      next: (data) => this.toastService.showSuccess(MessageText.success),
      error: (err) => this.toastService.showError(MessageText.wrongData),
    });
  }

  cloneOption(option: TenantMsGraphOptions) {
    this.notificationService.cloneMsGraphOptions(option.id!).subscribe(() => {
      this.toastService.showSuccess(MessageText.success);

      this.notificationService
        .getTenantMsGraphSetingsList(this.tenantId)
        .subscribe((x) => (this.emailTemplateItems = x));
    });
  }

  openModal(value: string) {
    this.showModalWindow = true;
    this.msGraphId = value;
  }

  onCloseModal() {
    this.showModalWindow = false;
    this.msGraphId = ' ';
  }
}
